import { render, staticRenderFns } from "./paymentComponent.vue?vue&type=template&id=b9c3a754&scoped=true&"
import script from "./paymentComponent.vue?vue&type=script&lang=js&"
export * from "./paymentComponent.vue?vue&type=script&lang=js&"
import style0 from "./paymentComponent.vue?vue&type=style&index=0&id=b9c3a754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c3a754",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9c3a754')) {
      api.createRecord('b9c3a754', component.options)
    } else {
      api.reload('b9c3a754', component.options)
    }
    module.hot.accept("./paymentComponent.vue?vue&type=template&id=b9c3a754&scoped=true&", function () {
      api.rerender('b9c3a754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/prekickoff/paymentComponent.vue"
export default component.exports